import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AppState } from '../app.state';

// Root app state selector
export const selectAppState = createFeatureSelector<AppState>('app');

export const selectSelectedPRF = createSelector(
    selectAppState,
    (state) => state?.selectedPRF
);

export const selectPrfName = createSelector(
    selectSelectedPRF,
    (selectedPRF) => selectedPRF?.prfname || null
);

export const selectPrfNumber = createSelector(
    selectSelectedPRF,
    (selectedPRF) => selectedPRF?.prfnumber || null
);

export const selectPrfYear = createSelector(
    selectSelectedPRF,
    (selectedPRF) => selectedPRF?.prfyear || null
);

export const selectGroupCode = createSelector(
    selectSelectedPRF,
    (selectedPRF) => selectedPRF?.groupcode || null
);

export const selectGroupReportEnabled = createSelector(
    selectSelectedPRF,
    (selectedPRF) => selectedPRF?.groupreportenabled || ''
);

export const selectPrfStatus = createSelector(
    selectSelectedPRF,
    (selectedPRF) => selectedPRF?.prfstatus || null
);
